import { CatalogicalGeneratedModel, ItemModel } from "lib/services/catalogical-models";

export enum Visibility {
  PRIVATE = "private",
  PUBLIC = "public",
  SHARED = "shared",
}

export enum Facts {
  JOB_FAMILY = "jobFamilyName",
}

export interface ListItem extends ItemModel {
  addedAt: Date;
  addedBy: string;
  status: string;
}

export interface ListModel {
  listId: string;
  name: string;
  description?: string;
  ownerAlias: string;
  items: ListItem[];
  itemCount: number;
  visibility: Visibility;
  fullItems: ItemModel[];
  allowedDomains: string[];
  tags: string[];
  evaluationRules?: Record<string, unknown>;
  /**
   * Autogenerated attributes by Catalogical
   */
  catalogicalGenerated?: CatalogicalGeneratedModel;
}

// Request/Response interfaces for Lists API
export interface GetListsResponse {
  lists: ListModel[];
  totalCount: number;
}

export interface GetListResponse {
  list: ListModel;
}

export interface CreateListRequest {
  name: string;
  description?: string;
  visibility?: string;
  allowedDomains?: string[];
  tags?: string[];
  itemIds?: string[];
}

export interface UpdateListRequest {
  name?: string;
  description?: string;
  visibility?: string;
  allowedDomains?: string[];
  tags?: string[];
}

export interface AddItemToListRequest {
  itemIds: string[];
  listId?: string;
  autoCreate?: boolean;
  name?: string;
  domain?: string;
}

export interface EvaluateListsRequest {
  attributes: Record<string, any>;
  domains?: string[];
  includeItemDetails?: boolean;
  limit?: number;
}

export interface ApplicableList {
  description: string;
  itemIds: string[];
  listId: string;
  name: string;
  reason: string;
  specificityScore: number;
  fullItems?: ItemModel[];
}

export interface EvaluateListsResponse {
  applicableLists: ApplicableList[];
}
